<template>
	<v-content-layout>
		<v-alert type="success" v-if="newlyAddedInvoiceNo && newlyAddedPONo">
			Successfully added. Here is the Invoice No: <strong>{{ newlyAddedInvoiceNo }}</strong>and PO No: <strong>{{ newlyAddedPONo }}</strong>.
		</v-alert>

		<template #header>
			<FilterOption />

			<div>
				<el-input size="small" class="ml-2" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
			</div>
			<v-spacer></v-spacer>
			<v-export-table text="Export" :tableColumns="getTableColumns" :tableData="records" :filename="`Invoice-Records-${Date.now()}`" :filesheet="`Invoice-Records`" />
		</template>

		<template #body>
			<e-table :data="records" :total="records.length" :headers="headers" :search="search" :loading="loading" :height="window.height - 170">
				<template #actions="{scope}">
					<el-button v-tooltip.top="'View Invoice Items'" size="mini" type="danger" icon="el-icon-view" @click="viewInvoiceItems(scope.row)"></el-button>
				</template>
				<template #expand="{props}">
					<p>Invoice Type: {{ props.row.type }}</p>
					<p>Audited By: {{ props.row.firstName }}</p>
					<p>Carrier: {{ props.row.carrierName }}</p>
					<p>Net Terms: {{ props.row.invoiceTerms }}</p>
					<p>Freight Charge: {{ props.row.dropShipFee === 'undefined' ? '0' : props.row.dropShipFee }}</p>
				</template>

				<template #footer>
					<el-button size="small" type="danger" icon="mdi mdi-filter-remove" @click="clearFilter"> Clear Filter</el-button>
					<el-button size="small" type="primary" icon="mdi mdi-refresh" @click="loadInvoiceRecords"> Reload</el-button>
				</template>
			</e-table>
		</template>
	</v-content-layout>
</template>

<script>
import FilterOption from './components/FilterOption';
import { state as globalState } from '../../store/store'
import { bus } from '../../main';
import { mapGetters, mapActions } from 'vuex';
import * as type from '../../store/types';
export default {
	components: { FilterOption },
	data(){
		return {
			...globalState,
			tableData : [],
			search: ''
		}
	},
	created(){
		this.loadInvoiceRecords({});
	},
	computed: {
		...mapGetters({
			headers: `invoicerecords/getHeaders`,
			records: `invoicerecords/getRecords`,
			loading: `global/loading`,
		}),
		getTableColumns(){
			return this.headers.filter(e => e.text !== 'Action').map(e => {
				return{
					label: e.text,
					field: e.value
				}
			})
		}
	},
	methods: {
		...mapActions({
			loadInvoiceRecords: `invoicerecords/${type.GET_INVOICE_RECORDS}`
		}),
		clearFilter(){
			bus.$emit('clearFilter')
			this.loadInvoiceRecords({});
		},
		viewInvoiceItems(item){
            this.$router.push(`/invoice-items?itemId=${item.id}&invoiceNo=${item.invoiceNumber}&purchaseOrderNumber=${item.purchaseOrderNumber}&invoiceType=${item.type}`)
		},
	},
	beforeDestroy(){
		globalState.newlyAddedInvoiceNo = ''
		globalState.newlyAddedPONo = ''
	}
};
</script>